module.exports = __webpack_public_path__ + "media/images/computer-p-1080-da174c242e35b037cb4f47cc5ed2aa79.jpeg";